import { render, staticRenderFns } from "./AdminPurchaseOrderOverview.vue?vue&type=template&id=0a556b39&scoped=true&"
import script from "./AdminPurchaseOrderOverview.vue?vue&type=script&lang=js&"
export * from "./AdminPurchaseOrderOverview.vue?vue&type=script&lang=js&"
import style0 from "./AdminPurchaseOrderOverview.vue?vue&type=style&index=0&id=0a556b39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a556b39",
  null
  
)

export default component.exports